<template>
	<div>
		<div class="scrollToTop" @click="scrollToTop">
			<i class="fa fa-2x fa-angle-up"></i>
		</div>
		<p class="m-0 mt-3 py-4 text-center">Thank you for offering us a <span class="text-logo-color font-weight-bold">WNDW</span> into your world of shopping !</p>
		<div class="processes d-none">
			<div class="process">
				<img src="/img/assure.png" height="40px" alt="" />
				<p>100% Orginal</p>
			</div>
			<!-- <div class="process">
				<img src="/img/shipping.png" height="40px" alt="" />
				<p>Shipping free above 799</p>
			</div> -->
			<div class="process">
				<img src="/img/rate.png" height="40px" alt="" />
				<p>COD available</p>
			</div>
			<div class="process">
				<img src="/img/return.png" height="40px" alt="" />
				<p>Easy Return</p>
			</div>
		</div>
		<div class="footer">
			<div class="headingList">
				
				<div  class="links">
					<h3
						class="footer__heading"
						@click="toggle('com')"
						:class="{ active: footer_active === 'com' }"
					>
						Company
					</h3>
					<div class="mobile-view" :class="{ active: footer_active === 'com' }">
						<ul class="footerLinks">
							<li
								class="footerLink"
								v-for="(item, i) in this.$root.pages.company"
								:key="i"
								v-if="item.include_footer_menu === 'yes'"
							>
								<router-link
									v-if="item.landing_page == null"
									:to="{
										path: '/page/' + item.url_key + '.html',
										params: {
											cat_id: item.id_category,
											menu_url_key: item.menu_url_key,
										},
									}"
									:key="item.id_category"
									>{{ item.name }}</router-link
								>
								<router-link
									v-else
									:to="{
										path: '/page/' + item.url_key + '.html',
										params: {
											cat_id: item.id_category,
											menu_url_key: item.menu_url_key,
										},
									}"
									:key="item.id_category"
									>{{ item.name }}</router-link
								>
							</li>
							
							<!-- <li
								v-for="(item, i) in this.$root.menu"
								:key="i"
								class="footerLink"
							>
								<router-link
									v-if="item.landing_page == null"
									:to="{
										path: item.menu_url_key + '.html',
										params: {
											cat_id: item.id_category,
											menu_url_key: item.menu_url_key,
										},
									}"
									:key="item.id_category"
									>{{ item.name }}</router-link
								>
								<router-link
									v-else
									:to="{
										path: '/collection/' + item.menu_url_key + '.html',
										params: {
											cat_id: item.id_category,
											menu_url_key: item.menu_url_key,
										},
									}"
									:key="item.id_category"
									>{{ item.name }}</router-link
								>
							</li> -->
						</ul>
					</div>
				</div>
				<div class="links">
					<h3
						class="footer__heading"
						@click="toggle('con')"
						:class="{ active: footer_active === 'con' }"
					>
						Customer Service
					</h3>
					<div class="mobile-view" :class="{ active: footer_active === 'con' }">
						<ul class="footerLinks">
							
							<!-- <li class="footerLink">
								<router-link :to="{ name: 'underDevelop' }">Payments</router-link>
							</li>
							<li class="footerLink">
								<router-link :to="{ name: 'underDevelop' }">Cancellation</router-link>
							</li> -->
							<li class="footerLink">
								<router-link :to="{ name: 'contact_us' }">Contact Us</router-link>
							</li>
							<!-- <li class="footerLink">
								<router-link :to="{ name: 'underDevelop' }">Frequently Asked Questions</router-link>
							</li>
							<li class="footerLink">
								<router-link :to="{ name: 'underDevelop' }">Offers & Promotions
</router-link>
							</li>
							<li class="footerLink">
								<router-link :to="{ name: 'underDevelop' }">Returns & Refunds
</router-link>
							</li>
							<li class="footerLink">
								<router-link :to="{ name: 'underDevelop' }">Return To Store</router-link>
							</li> -->

							
							<!-- <li
								v-for="(item, i) in this.$root.menu.customer_service"
								:key="i"
								class="footerLink"
							>
								<router-link
									v-if="item.landing_page == null"
									:to="{
										path: item.menu_url_key + '.html',
										params: {
											cat_id: item.id_category,
											menu_url_key: item.menu_url_key,
										},
									}"
									:key="item.id_category"
									>{{ item.name }}</router-link
								>
								<router-link
									v-else
									:to="{
										path: '/collection/' + item.menu_url_key + '.html',
										params: {
											cat_id: item.id_category,
											menu_url_key: item.menu_url_key,
										},
									}"
									:key="item.id_category"
									>{{ item.name }}</router-link
								>
							</li> -->
							<li
								class="footerLink"
								v-for="(item, i) in this.$root.pages.customer_service"
								:key="i"
								v-if="item.include_footer_menu === 'yes'"
							>
								<router-link
									v-if="item.landing_page == null"
									:to="{
										path: '/page/' + item.url_key + '.html',
										params: {
											cat_id: item.id_category,
											menu_url_key: item.menu_url_key,
										},
									}"
									:key="item.id_category"
									>{{ item.name }}</router-link
								>
								<router-link
									v-else
									:to="{
										path: '/page/' + item.url_key + '.html',
										params: {
											cat_id: item.id_category,
											menu_url_key: item.menu_url_key,
										},
									}"
									:key="item.id_category"
									>{{ item.name }}</router-link
								>
							</li>
						</ul>
					</div>
				</div>
				<div v-if="this.$root.customerDetails.name.length" class="links">
					<h3
						class="footer__heading"
						@click="toggle('pol')"
						:class="{ active: footer_active === 'pol' }"
					>
						My WNDW
					</h3>
					<div class="mobile-view" :class="{ active: footer_active === 'pol' }">
						<ul class="footerLinks">
							<li class="footerLink">
								<router-link :to="{ name: 'profile' }">My Account</router-link>
							</li>
							 

							<li class="footerLink">
								<router-link :to="{ name: 'order' }">My Orders</router-link>
							</li>
							<!-- <li class="footerLink"><a href="#">Contact Us</a></li> -->
							<li class="footerLink">
								<router-link :to="{ name: 'Wishlist' }">My Wishlist</router-link>
							</li>
							<li class="footerLink">
								<router-link :to="{ name: 'StoreCredit' }"
									>My WNDW Credits</router-link
								>
							</li>
						</ul>
					</div>
				</div>
				<div class="links">
					<!-- <h3
						class="footer__heading"
						@click="toggle('cat')"
						:class="{ active: footer_active === 'cat' }"
					>
						ONLINE SHOPPING
					</h3>
					<div class="mobile-view" :class="{ active: footer_active === 'cat' }">
						<ul class="footerLinks"> -->

					<!-- <li
								class="footerLink"
								v-for="(item, i) in this.$root.menu"
								:key="i"
							>
								<router-link
									v-if="item.landing_page == null"
									:to="{
										path: '/category/' + item.menu_url_key + '.html',
										params: {
											cat_id: item.id_category,
											menu_url_key: item.menu_url_key,
										},
									}"
									:key="item.id_category"
									>{{ item.name }}</router-link
								>
								<router-link
									v-else
									:to="{
										path: '/collection/' + item.menu_url_key + '.html',
										params: {
											cat_id: item.id_category,
											menu_url_key: item.menu_url_key,
										},
									}"
									:key="item.id_category"
									>{{ item.name }}</router-link
								>
							</li> -->
					<!-- </ul>
					</div> -->
				</div>
			</div>
			<div class="inputBox">
				<div>
					<p>SUBSCRIBE TO OUR NEWSLETTER</p>
					<div class="inputNews">
						<input
							@keyup="user_email"
							v-model="email"
							class="inputField"
							placeholder="Your email address"
							type="text"
						/>
						<button class="btnNews" @click="RegisterEmailForNewsletter">Subscribe</button>
					</div>
					<p v-show="email_error" class="text-danger" style="color: red !important" > {{email_error}}</p>
				</div>
				<div class="connectBox">
					<p>CONNECT WITH US</p>
					<div class="connectIcon">
						<a href="https://www.instagram.com/wndw.india/"><i class="fa fa-instagram"></i></a>
						<a href="https://www.facebook.com/wndw.india"><i class="fa fa-facebook-official"></i></a>
						<a href="https://twitter.com/WNDW_India"><i class="fa fa-twitter-square"></i></a>
						<a href="https://www.youtube.com/channel/UCFJFj5rRBpje_rA7whBrcvw"><i class="fa fa-youtube-play"></i></a>
					</div>
				</div>
			</div>
		</div>
		<div class="copyright">
			<div class="content">Copyright © 2021 WNDW</div>
			<div class="logo">
				<img height="45" src="/img/GH_logo.png" />
			</div>
		</div>
	</div>
</template>
<style >
	.inputBox p{
		color: #fff !important;
	}
	.scrollToTop {
		display: none; /* Hidden by default */
		position: fixed; /* Fixed/sticky position */
		bottom: 55px; /* Place the button at the bottom of the page */
		right: 30px; /* Place the button 30px from the right */
		z-index: 99; /* Make sure it does not overlap */
		border: none; /* Remove borders */
		outline: none; /* Remove outline */
		background-color: var(--main-color); /* Set a background color */
		color: white; /* Text color */
		cursor: pointer; /* Add a mouse pointer on hover */
		padding: 7px; /* Some padding */
		width: 50px;
		height: 50px;
		/* width: 50px; */
		/* height: 0px; */
		text-align: center;
		border-radius: 50%; /* Rounded corners */
		/* Increase font size */
	}
	.scrollToTop.active {
		display: block;
	}
	/* .scrollToTop::before {
		  content: "";
		  font: normal normal normal 14px/1 FontAwesome;;
		  padding: 10px;
		} */
	::placeholder {
		font-size: 14px;
		font-family: "lhmRegular";
	}
	.inputBox {
		display: flex;
		flex-direction: column;
		justify-content: center;
		/* align-items: center;
		align-self: center; */
	}
	.processes {
		display: flex;
		justify-content: space-around;
		align-items: center;
		padding: 1rem;
		background: #ffffff;
		padding-left: 10%;
		padding-right: 10%;
		margin: 0px !important;
	}
	.process {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}
	.process > img {
		padding-right: 0.5rem;
	}
	.process > p {
		margin: auto;
		color: #7f7f7f;
		font-size: 16px;
		font-family: "lhmRegular";
		text-transform: uppercase;
	}
	.footer {
		background: #202020;
		padding: 60px 120px;
		display: flex;
		justify-content: space-between;
	}

	.headingList {
		display: flex;
		justify-content: space-between;
		font-family: "lhmBold";
		font-size: 15px;
		text-transform: uppercase;
		line-height: 24px;
		color: #7f7f7f;
		flex: 0 0 60%;
	}
	.footer__heading {
		font-size: 16px;
		font-family: "lhmBold";
		color: #fff;
	}
	/* .footer__heading::after {
		  content: "+";
		  position: absolute;
		right: 10px;

		} */
	/* .footer__heading.active::after{
		  content: "-";
		  position: absolute;
		right: 10px;
		} */
	ul.footerLinks {
		width:100%;
		list-style: none;
		margin-left: 0;
		margin: 0;
		padding: 0;
		float: left;
	}
	li.footerLink {
		padding: 5px 0px;
	}
	li.footerLink > a {
		color: #7f7f7f;
		text-decoration: none;
		font-family: "lhmSemiBold";
		font-size: var(--font-size-regular);
		line-height: 24px;
		text-transform: capitalize;
	}
	li.footerLink > a.router-link-active {
		padding: 0px !important;
		color: #7f7f7f  !important;
	}
	li.footerLinks > a:hover {
		color: var(--font-dark-blue);
	}
	.inputNews {
		align-self: center;
		/* display: flex; */
		width: 100%;
		border: none;
		box-sizing: none;
	}
	.inputField {
		padding: 14px 12px;
		width: 100%;
		background: #dadada;
		outline: none;
		border: none;
	}
	.btnNews {
		background: #626262;
		color: #eeeeee;
		padding: 14px 12px;
		font-family: "lhmRegular";
		font-size: var(--font-size-regular);
		-webkit-box-shadow: none;
		box-shadow: none;
		margin-top: 10px;
		border: 0;
		cursor: pointer;
		width: 100%;
		text-transform: uppercase;
	}
	.copyright {
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 1rem 0.75rem;
	}
	.content {
		font-size: 14px;
		}
	.logo {
		margin-left: auto;
		align-self: flex-end;
	}
	@keyframes slide {
		from {
			opacity: 0;
			transform: translate3d(0, 0, 10%);
		}
		to {
			opacity: 1;
			transform: translate3d(0, 0, 0);
		}
	}

	/* Responsive  */
	@media screen and (max-width: 767px) {
		
		.fa-twitter-square:before{
			color:black !important
		}
		.fa-facebook-official:before{
			color:black !important
		}
		.fa-instagram:before{
			color:black !important
		}
		.fa-youtube-play:before{
			color:black !important
		}
		.inputBox p{
			color: black !important;
		}
		.scrollToTop {
			display: none !important;
		}
		.processes {
			margin-left: 2% !important;
			margin-right: 2% !important;
			padding-left: 2% !important;
			padding-right: 2% !important;
		}
		.footer {
			display: flex;
			flex-direction: column;
			padding: 15px;
		}
		.process {
			flex-direction: column;
		}
		.footer__heading::after {
			content: "+";
			position: absolute;
			right: 16px;
			font-size: 20px;
		}
		.footer__heading.active::after {
			content: "-";
			position: absolute;
			right: 16px;
			font-size: 26px;
		}
		.footer__heading {
			font-size: 14px;
			letter-spacing: 1px;
			color: #333;
			margin: 0;
			position: relative;
		}
		.process > p {
			font-size: 14px;
			/* word-spacing: 100vw; */
			text-align: center;
			word-break: normal;
		}
		.input {
			display: none;
		}
		.headingList {
			flex-direction: column;
			justify-content: center;
		}
		.mobile-view {
			display: none;
			opacity: 0;
		}
		.inputBox {
			margin-top: 20px;
			/* display: none; */
		}

		.mobile-view.active {
			padding: 1px 16px;
			display: block;
			opacity: 1;
			transition: all 0.5s ease-in-out;
			animation: slide 0.5s ease-in both;
			transition: displqy 600ms ease-out, height 600ms ease-out;
		}

	}
</style>

<script>
import axios from 'axios'

	export default {
		name: "Footer",
		data: function () {
			return {
				footer_active: "",
				email: '',
				email_error: ''
			};
		},
		methods: {
			RegisterEmailForNewsletter () {
				if(this.email != '' && this.email_error == '') {
					var form = new FormData();
					form.append("email", this.email);
					axios.post(this.$root.cart_api + "/customer/newsletter", form)
						.then((response) => {
							if (response.data.success === true) {
								this.$toast.success(response.data.message, {
									position: "top",
									duration: 4000,
								});
							} else {
								this.$toast.error(response.data.message, {
									position: "top",
									duration: 4000,
								});
								
							}
						})
						.catch((error) => {
							
							if (error.message === "Network Error") {
								this.$toast.error(
									"Oops there seems to be some Network issue, please try again.",
									{
										position: "top",
										duration: 4000,
									}
								);
							}
							window.scrollTo(0, 0);
						});
				}

			},
			user_email() {
				// console.log("called");
				var email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				if (this.email.match(email)) {
					this.email_error = "";
				} else {
					this.email_error = "Please enter valid Email";
				}
			},
			scrollToTop() {
				window.scrollTo(0, 0);
			},
			toggle(name) {
				if (name != this.footer_active) {
					this.footer_active = name;
				} else {
					this.footer_active = "";
				}
			},
		},
		mounted() {
			// window.addEventListener("resize", () => {
			// 	windowWidth = window.innerWidth;
			// });

			window.addEventListener("scroll", function (e) {
				let scrollToTop = document.getElementsByClassName("scrollToTop");

				if (window.pageYOffset > 500) {
					scrollToTop[0].classList.add("active");
				} else {
					scrollToTop[0].classList.remove("active");
				}
			});
		},
	};
</script>